<template>
    <header class="header-global">
        <base-nav v-if="!oracle.isMobile()" class="navbar-main" transparent type="" effect="light" expand>
            <div style="font-size: 17px" slot="brand" role="button" @click="oracle.newTab('https://visternet.com')"
                         class="navbar-brand mr-lg-5 align-center justify-center text-default" >
                <img :src="require('@/assets/image/logo.png')" alt="VISTERNET">
            </div>
<div class="mr-auto ml-auto"></div>
<!--            <ul :class="('navbar-nav navbar-nav-hover align-items-lg-center ') + (isEN ? 'mr-auto' : 'ml-auto mr-3')">-->
<!--                <li class="nav-item-ho">-->
<!--                    <span role="button" slot="title" @click="$router.push('/')" class="nav-link"-->
<!--                       data-toggle="dropdown">-->
<!--                        <i class="ni ni-ui-04 d-lg-none"></i>-->
<!--                        <span :class="[current_page == '/'  ? 'nav-selected-color': 'nav-unselected-color',  'nav-link-inner&#45;&#45;text' ]">-->
<!--                            {{language.lang('Home')}}</span>-->
<!--                    </span>-->
<!--                </li>-->
<!--                <li class="nav-item-ho">-->
<!--                    <span slot="title" href="" @click="$router.push('/consultants')" class="nav-link"-->
<!--                          data-toggle="dropdown"-->
<!--                          role="button">-->
<!--                        <i class="ni ni-ui-04 d-lg-none"></i>-->
<!--                        <span :class="[current_page == '/consultants'  ? 'nav-selected-color': 'nav-unselected-color',  'nav-link-inner&#45;&#45;text' ]">-->
<!--                            {{language.lang('Find a consultant')}}</span>-->
<!--                    </span>-->
<!--                </li>-->
<!--                <li class="nav-item-ho">-->
<!--                    <span slot="title" href="" @click="$router.push('/blog')" class="nav-link"-->
<!--                          data-toggle="dropdown"-->
<!--                          role="button">-->
<!--                        <i class="ni ni-ui-04 d-lg-none"></i>-->
<!--                        <span :class="[current_page == '/blog'   ? 'nav-selected-color': 'nav-unselected-color',  'nav-link-inner&#45;&#45;text' ]">-->
<!--                            {{language.lang('Blog')}}</span>-->
<!--                    </span>-->
<!--                </li>-->
<!--                &lt;!&ndash;                <li class="nav-item-ho">&ndash;&gt;-->
<!--                &lt;!&ndash;                    <span slot="title" href="" @click="$router.push('/video')" class="nav-link"&ndash;&gt;-->
<!--                &lt;!&ndash;                          data-toggle="dropdown"&ndash;&gt;-->
<!--                &lt;!&ndash;                          role="button">&ndash;&gt;-->
<!--                &lt;!&ndash;                        <i class="ni ni-ui-04 d-lg-none"></i>&ndash;&gt;-->
<!--                &lt;!&ndash;                        <span :class="[current_page == '/video'   ? 'nav-selected-color': 'nav-unselected-color',  'nav-link-inner&#45;&#45;text' ]">&ndash;&gt;-->
<!--                &lt;!&ndash;                            {{language.lang('Video')}}</span>&ndash;&gt;-->
<!--                &lt;!&ndash;                    </span>&ndash;&gt;-->
<!--                &lt;!&ndash;                </li>&ndash;&gt;-->
<!--                <li class="nav-item-ho">-->
<!--                    <span slot="title" href="" @click="$router.push('/about')" class="nav-link"-->
<!--                          data-toggle="dropdown"-->
<!--                          role="button">-->
<!--                        <i class="ni ni-ui-04 d-lg-none"></i>-->
<!--                        <span :class="[current_page == '/about'  ? 'nav-selected-color': 'nav-unselected-color',  'nav-link-inner&#45;&#45;text' ]">-->
<!--                            {{language.lang('About')}}</span>-->
<!--                    </span>-->
<!--                </li>-->
<!--                &lt;!&ndash;                <li class="nav-item-ho">&ndash;&gt;-->
<!--                &lt;!&ndash;                    <span slot="title" href="" @click="$router.push('/rules')" class="nav-link"&ndash;&gt;-->
<!--                &lt;!&ndash;                          data-toggle="dropdown"&ndash;&gt;-->
<!--                &lt;!&ndash;                          role="button">&ndash;&gt;-->
<!--                &lt;!&ndash;                        <i class="ni ni-ui-04 d-lg-none"></i>&ndash;&gt;-->
<!--                &lt;!&ndash;                        <span :class="[current_page == '/rules'  ? 'nav-selected-color': 'nav-unselected-color',  'nav-link-inner&#45;&#45;text' ]">&ndash;&gt;-->
<!--                &lt;!&ndash;                            {{language.lang('Terms of use')}}</span>&ndash;&gt;-->
<!--                &lt;!&ndash;                    </span>&ndash;&gt;-->
<!--                &lt;!&ndash;                </li>&ndash;&gt;-->
<!--                <li class="nav-item-ho">-->
<!--                    <span slot="title" href="" @click="$router.push('/contact')"-->
<!--                          class="nav-link"-->
<!--                          data-toggle="dropdown"-->
<!--                          role="button">-->
<!--                        <i class="ni ni-ui-04 d-lg-none"></i>-->
<!--                        <span :class="[current_page == '/contact' ? 'nav-selected-color': 'nav-unselected-color',  'nav-link-inner&#45;&#45;text' ]">-->
<!--                            {{language.lang('Contact')}}</span>-->
<!--                    </span>-->
<!--                </li>-->
<!--            </ul>-->
            <ul class="navbar-nav align-items-lg-center"
                :style="isEN ? 'margin-left: unset !important;' : 'margin-right: unset !important;' ">
                <li :class="[!isEN ? 'm-left' : 'm-right' , 'nav-item response-l1']">
                    <div class="hv-header-nav-lang">
                        <v-menu
                                open-on-hover
                                :open-delay="100"
                                bottom
                                offset-y
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <div role="button" v-bind="attrs" class="d-flex flex-row" v-on="on" >
                                    <i :class="isEN ? 'ml-2 mr-1' : 'mr-2 ml-1'" style="align-self: center" class="fa fa-angle-down text-white "></i>
                                    <span :class="isEN ? 'mr-2' : 'ml-2'" class="" style="color: white; align-self: center;">{{isEN ? "EN" : "FA"}}</span>
                                </div>
                            </template>
                            <v-list rounded style="background-color: #427BD5">
                                <v-list-item @click="selected = item.title"
                                             style="min-width: 80px; color: #fff !important" ripple
                                             class="font-weight-bold"
                                             v-for="(item, index) in langMenus"
                                             :key="index"
                                >
                                    <v-list-item-icon><i :class="item.icon"></i></v-list-item-icon>
                                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </li>
                <li class="nav-item avatar-header" v-if="isLoggedIn">
                    <router-link role="button" :to="isLawyer ? '/accounts' : '/profile'">
                        <span>
                            <img :class="'shadow-lg--hover ' + (isEN? 'mr-2' : 'ml-2')"
                                 :src="user != null && user.user_avatar != null ? user.user_avatar :
                                 lawyer != null && lawyer.lawyer_cover != null ? lawyer.lawyer_cover :
                                 require('@/assets/image/user_avatar.png')"
                                 alt="">
                        </span>
                        <span :class="'btn-inner--icon font-weight-bold text-default response-l2'">{{(isEN? 'Hi ' : 'سلام ') + (user != null ? user.username : lawyer != null ? lawyer.lawyer_title : language.lang("Guest!"))}}</span>
                    </router-link>
                </li>
                <li class="nav-item" v-if="!isLoggedIn">
                    <v-menu
                            open-on-hover
                            :open-delay="100"
                            bottom
                            offset-y
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <span role="button"
                                    v-bind="attrs"
                                    v-on="on" class="text-default btn-inner--icon text-underline font-weight-bold">
                                {{language.lang(`Sign In`)}}
                            </span>
                        </template>
                        <v-list rounded style="background-color: #427BD5">
                            <v-list-item @click="$router.push(item.to)" link
                                         style="min-width: 150px; color: #fff !important" ripple
                                         class="font-weight-bold"
                                         v-for="(item, index) in menus"
                                         :key="index"
                            >
                                <v-list-item-icon><i :class="item.icon"></i></v-list-item-icon>
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </li>
            </ul>
        </base-nav>
        <div v-else style="text-align: center; margin-top: 20px; margin-bottom: 10px">
            <img class="" style="width: 70%; height: auto; margin-left: auto; margin-right: auto;"
                 :src="require('@/assets/image/logo.png')" alt="VISTERNET">
        </div>
    </header>
</template>
<script>
    import BaseNav from "@/components/micro/BaseNav";
    import BaseDropdown from "@/components/micro/BaseDropdown";
    import CloseButton from "@/components/micro/CloseButton";
    import oracle from "@/utils/oracle";
    import language from "@/utils/language";

    export default {
        components: {
            BaseNav,
            CloseButton,
            BaseDropdown
        },
        data() {
            return {
                langMenus: [
                    {title: "FA", icon: 'fa fa-language'},
                    {title: "EN", icon: 'fa fa-language'},],
                menus: [
                    {title: language.lang('User Dashboard'), to: '/register', icon: 'fa fa-user-circle'},
                    {title: language.lang('Consultant Dashboard'), to: '/accounts/login', icon: 'fa fa-user-o'},
                ],
                lawyer: null,
                user: null,
                oracle: oracle,
                isEN: oracle.isEN(),
                selected: oracle.isEN() ? "EN" : "FA",
                isLoggedIn: oracle.isLoggedIn(),
                language: language,
                current_page: '',
                isLawyer: false,
            }
        }, methods: {
            openLanguageChooser() {
                let el = document.getElementById('lang-select')
                el.click()
            },
            initType() {
                this.isLawyer = oracle.isLawyer()
                return this.isLawyer
            },
            getProfile() {
                if (oracle.isLoggedIn()) {
                    if (this.isLawyer) {
                        oracle.axios('lawyer/getProfile', null, (response) => {
                            this.lawyer = response.data
                        })
                    } else {
                        oracle.axios('user/getProfile', null, (response) => {
                            this.user = response.data
                        })
                    }
                }
            }
        },
        watch: {
            '$route': function (to, from) {
                this.initType()
                this.current_page = to.path.toLowerCase()
            },
            selected: function (to, from) {
                if (to != null && from != null) {
                    oracle.setData("lang", to);
                    oracle.send(oracle.REFRESH)
                }
            }
        },
        mounted() {
            this.initType()
            this.current_page = this.$router.history.current.path
            this.getProfile()
            this.$root.$on('islogin', () => {
                this.isLoggedIn = oracle.isLoggedIn()
                this.initType()
                this.getProfile()
            })
        }
    };
</script>
<style>
    .style-aline .dropdown-menu {
        text-align: right !important;
    }

    .hv-header-nav-lang {
        padding: 3px;
        background-color: #427BD5;
        border-radius: 5px;
    }

    .hv-header-nav-lang select {
        padding: 0;
        margin: 0;
        width: 30px;
        color: white;
    }

    .avatar-header img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }

    .avatar-header {
        color: white;
    }

    .nav-link-inner--text {
        color: #515151;
        font-weight: bold;
    }

    .nav-unselected-color {
        color: #515151;
    }

    .nav-selected-color {
        color: #427BD5;
        position: relative;
    }

    .nav-selected-color:after {
        position: absolute;
        content: '';
        height: 3px;
        background-color: #427BD5;
        width: 100%;
        border-radius: 20px;
        transform: translateX(-50%);
        bottom: -10px;
        left: 50%;
    }

    .m-left {
        margin-left: 15px
    }

    .m-right {
        margin-right: 15px !important;
    }

    @media only screen and (max-width: 600px) {
        .nav-link-inner--text {
            font-size: 9px;
        }
    }

    @media only screen and (max-width: 992px) {
        .navbar-transparent .navbar-toggler {
            background-color: black !important;
        }
    }

    @media only screen and (max-width: 1200px) {
        /*.response-l1 {*/
        /*    width: 17% !important;*/
        /*}*/
        .m-left {
            margin-left: 2px !important;
        }

        .m-right {
            margin-right: 2px !important;
        }

        .avatar-header img {
            width: 35px;
            height: 35px;
        }

        .avatar-header .response-l2 {
            font-size: 12px;
        }

        .container {
            max-width: 1000px !important;
        }

    }

    @media (min-width: 2000px) {
        .container {
            max-width: 1800px !important;
        }
    }

    @media (min-width: 1200px) {
        .container {
            max-width: 1200px !important;
        }


    }
</style>
